import { sheetV1 } from "@otto-ec/otto-components/sheet";

export function getActiveSheet() {
  return window.o_global.pali.sheet?.getActiveSheet();
}

export function getOcActiveSheet(): sheetV1 {
  return sheetV1.current.get().instance;
}
